/* The first look: checks each step, then lets the form post normally so Shopify's own spam check runs (a background post
   is refused for lack of its token). The page returns with the next step open. Also decides when the card may appear. */
(() => {
  const STATE = 'maison:first-look';
  const PAGES = 'maison:first-look-pages';
  const EMAIL = 'maison:first-look-email';
  const read = (store, key) => { try { return store.getItem(key); } catch (e) { return null; } };
  const write = (store, key, value) => { try { store.setItem(key, value); } catch (e) { /* private window */ } };

  const roots = [...document.querySelectorAll('[data-mfl]')];
  const card = document.querySelector('[data-mfl-card]');

  /* ---------- Steps ---------- */
  const show = (root, name, focus) => {
    root.querySelectorAll('[data-mfl-step]').forEach((step) => { step.hidden = step.dataset.mflStep !== name; });
    const target = root.querySelector(`[data-mfl-step="${name}"] [data-mfl-focus]`);
    if (focus && target) target.focus({ preventScroll: true });
  };
  const showError = (form, message, box) => {
    const el = form.querySelector('[data-mfl-error]');
    el.textContent = message || '';
    el.hidden = !message;
    if (box) box.classList.toggle('is-wrong', !!message);
  };
  const busy = (form) => {
    const button = form.querySelector('[type="submit"]');
    if (!button) return;
    button.setAttribute('aria-busy', 'true');
    // Shopify's spam check runs before the page moves on; never leave the button stuck if it takes a while.
    setTimeout(() => button.removeAttribute('aria-busy'), 8000);
  };

  roots.forEach((root) => {
    const emailForm = root.querySelector('.mfl-form--email');
    const waForm = root.querySelector('.mfl-form--whatsapp');
    const source = root.dataset.mflSource;
    const emailInput = emailForm.querySelector('[type="email"]');
    emailForm.noValidate = true; // our own message, in place of the browser's bubble

    const inCard = card && card.contains(root);
    const bringBack = () => {
      if (inCard) openCard();
      else root.scrollIntoView({ block: 'center' });
    };

    // The form has posted and the page has come back with an answer
    const problem = emailForm.querySelector('[data-mfl-server-error]');
    if (problem && /taken|already/i.test(problem.textContent)) {
      write(localStorage, STATE, 'joined');
      show(root, 'whatsapp', false);
      bringBack();
    } else if (problem) {
      showError(emailForm, problem.textContent.trim(), emailInput.parentElement);
      bringBack();
    } else if (emailForm.querySelector('[data-mfl-posted]')) {
      write(localStorage, STATE, 'joined');
      show(root, 'whatsapp', false);
      bringBack();
    }
    if (waForm.querySelector('[data-mfl-posted]')) {
      finish(root, 'Your first look will reach you by email and WhatsApp, before it reaches the site.');
      bringBack();
    }

    emailInput.addEventListener('input', () => showError(emailForm, '', emailInput.parentElement));
    emailForm.addEventListener('submit', (event) => {
      const email = emailInput.value.trim();
      if (!emailInput.checkValidity() || !email) {
        event.preventDefault();
        showError(emailForm, 'Please enter your full email address, such as name@email.com.', emailInput.parentElement);
        emailInput.focus();
        return;
      }
      write(sessionStorage, EMAIL, email);
      busy(emailForm);
    });

    const phoneInput = waForm.querySelector('[type="tel"]');
    const consent = waForm.querySelector('[data-mfl-consent]');
    const wording = waForm.querySelector('[data-mfl-wording]');
    phoneInput.addEventListener('input', () => showError(waForm, '', phoneInput.parentElement));
    consent.addEventListener('change', () => showError(waForm, ''));

    waForm.noValidate = true;
    waForm.addEventListener('submit', (event) => {
      let digits = phoneInput.value.replace(/\D/g, '');
      if (digits.length === 12 && digits.startsWith('91')) digits = digits.slice(2);
      if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
      if (!/^[6-9]\d{9}$/.test(digits)) {
        event.preventDefault();
        showError(waForm, 'Please enter a 10-digit Indian mobile number.', phoneInput.parentElement);
        phoneInput.focus();
        return;
      }
      if (!consent.checked) {
        event.preventDefault();
        showError(waForm, 'Please tick the box so we may message you, or choose "No, thank you".');
        consent.focus();
        return;
      }
      const email = read(sessionStorage, EMAIL) || emailInput.value.trim();
      waForm.querySelector('[data-mfl-email-copy]').value = email;
      phoneInput.value = `+91 ${digits}`;
      waForm.querySelector('[data-mfl-record]').value = [
        'WhatsApp first-look permission',
        `Number: +91 ${digits}`,
        `Email: ${email}`,
        `Wording agreed: ${wording.textContent.trim()}`,
        `Where: ${source}, ${location.pathname}`,
        `When: ${new Date().toISOString()}`
      ].join('\n');
      busy(waForm);
    });

    root.querySelector('[data-mfl-skip]').addEventListener('click', () => finish(root));
  });

  function finish(root, text) {
    if (text) root.querySelector('[data-mfl-done-text]').textContent = text;
    show(root, 'done', true);
    if (card && card.contains(root)) setTimeout(() => hideCard(true), 7000);
  }

  /* ---------- The invitation card ---------- */
  function openCard() {
    if (!card || !card.hidden) return;
    card.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => card.classList.add('is-in')));
  }
  function hideCard(remember) {
    if (!card || card.hidden) return;
    if (remember && read(localStorage, STATE) !== 'joined') write(localStorage, STATE, 'closed');
    card.classList.remove('is-in');
    card.classList.add('is-out');
    setTimeout(() => { card.hidden = true; card.classList.remove('is-out'); }, 420);
  }

  if (!card) return;
  card.querySelector('[data-mfl-close]').addEventListener('click', () => hideCard(true));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !card.hidden) hideCard(true); });

  if (window.Shopify && window.Shopify.designMode) {
    const section = card.closest('.shopify-section');
    document.addEventListener('shopify:section:select', (event) => { if (section && event.target === section) openCard(); });
    document.addEventListener('shopify:section:deselect', (event) => { if (section && event.target === section) hideCard(false); });
    return;
  }

  const pages = Number(read(sessionStorage, PAGES) || 0) + 1;
  write(sessionStorage, PAGES, String(pages));
  if (read(localStorage, STATE) || !card.hidden || document.documentElement.classList.contains('m-app') || document.documentElement.classList.contains('m-search-page')) return;

  // Waits its turn: never over the opening screen, an open menu, the bag or search, or while someone is typing.
  const occupied = () => {
    if (document.documentElement.hasAttribute('data-mn-active')) return true;
    if (document.querySelector('.mh-fixed.is-open, .mh-fixed.is-search, .m-app-note')) return true;
    if ([...document.querySelectorAll('[role="dialog"][aria-modal="true"]:not([hidden])')].some((el) => getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).display !== 'none')) return true;
    const active = document.activeElement;
    return !!active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
  };
  const delay = Number(pages > 1 ? card.dataset.mflNext : card.dataset.mflFirst) * 1000;
  const attempt = () => {
    if (read(localStorage, STATE)) return;
    if (occupied()) { setTimeout(attempt, 2000); return; }
    openCard();
  };
  setTimeout(attempt, delay);
})();
